type Targets = Record<string, HTMLSelectElement>;

export const getElement = (target: string): HTMLSelectElement | null =>
  document.querySelector<HTMLSelectElement>(`[rsmonitor="${target}"]`);

export const getTarget = (element: Element, attribute: string): HTMLSelectElement | undefined => {
  const targetName = element.getAttribute(attribute);
  if (targetName) {
    const target = getElement(targetName);
    if (target) {
      return target;
    }
  }
  return undefined;
};

const isFull = <T extends Record<string, unknown>>(check: T, against: Record<string, unknown>): check is T => {
  for (const key in against) {
    if (!check[key]) {
      return false;
    }
  }
  return true;
};

export const getTargets = <T extends Record<string, string>>(
  dateMap: T,
  element: Element
): Record<keyof T, HTMLSelectElement> => {
  const targets: Partial<Record<keyof T, HTMLSelectElement>> = {};
  for (const key in dateMap) {
    targets[key] = getTarget(element, dateMap[key]);
  }
  if (isFull(targets, dateMap)) {
    return targets as Record<keyof T, HTMLSelectElement>;
  } else if (element.parentElement) {
    return getTargets(dateMap, element.parentElement);
  }
  throw new Error();
};

export const getValues = <T extends Record<string, HTMLSelectElement>>(targets: T): Record<keyof T, string> => {
  return Object.fromEntries(
    Object.entries<HTMLSelectElement>(targets).map(([dateType, element]) => [dateType, element.value])
  ) as Record<keyof T, string>;
};

export const notifyTarget = (element: HTMLSelectElement): void => {
  element.dispatchEvent(
    new Event("input", {
      bubbles: true,
    })
  );
};

export const notifyTargets = <T extends Targets>(thisElement: keyof T, targets: T): void => {
  for (const key in targets) {
    if (key !== thisElement) {
      notifyTarget(targets[key]);
    }
  }
};

export const isFutureDate = (month: string, year: string): boolean =>
  !!(month && year && Date.parse(`01 ${month} ${year}`) > Date.now());
